import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface SearchProps<T> {
  searchTerm: string;
  itemName: string;
  setSearchTerm: (term: string) => void;
  handleSearchChange: (event: any) => void;
}

const Search = <T,>({
  searchTerm,
  itemName,
  setSearchTerm,
  handleSearchChange
}: SearchProps<T>) => {
  return (
    <div className="w-full sm:max-w-sm max-w-md relative">
      <label htmlFor="search" className="sr-only">
        {`Search ${itemName}s`}
      </label>
      <div className="relative">
        {/* Search icon on the left */}
        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
          <MagnifyingGlassIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
        </div>

        <input
          id="search"
          type="text"
          placeholder={`Search ${itemName}s`}
          onChange={handleSearchChange}
          value={searchTerm}
          className="block w-full rounded-md border border-gray-300 bg-white py-2 px-10 b-0 text-gray-900 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 sm:text-sm transition"
        />

        {/* Clear (X) button on the right */}
        {searchTerm && (
          <button
            type="button"
            onClick={() => setSearchTerm('')}
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Search;
